import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { baseUrlFunc } from '../../app/app.module';
import { HttpInterceptorProvider, Filter } from '../http-interceptor/http-interceptor';
import { UserProvider } from '../user/user';

/*
  Generated class for the DocumentosProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class DocumentosProvider {

  apiBase = baseUrlFunc() + "wp/v2/estudoscientificos"

  constructor(public http: HttpInterceptorProvider,
    public userProvider: UserProvider) {
    console.log('Hello DocumentosProvider Provider');
  }

  solicitarDocumentos(filter?: Array<Filter>): Observable<any> {
    return Observable.create(observer => {

      this.http.getFiltered(this.apiBase, filter).subscribe(data => {
        observer.next(data)
        console.log("register success response", data)
      }, err => {
        observer.error(err)
        console.log("register error response", err)
      })
    })
  }

  informDocumentVisualization(documentId: string): Observable<any> {
    return Observable.create(observer => {
      this.http.get(this.apiBase + "/" + documentId).subscribe(data => {

        let currentUser = this.userProvider.getUserStoraged()
        let users = data.acf.usuarios_visualizados

        if (users != undefined) {
          users = users + "," + currentUser.general.data.ID
        } else {
          users = currentUser.general.data.ID
        }

        let body = {}
        body["acf_fields"] = {}
        body["acf_fields"]["usuarios_visualizados"] = users

        this.http.post(this.apiBase + "/" + documentId, body).subscribe(data => {
          observer.next(data)
        }, err => {
          observer.error(err)
        })
      }, err => {
        observer.error(err)
      })

    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/documentos/documentos.ts